/**
 * GridLines Component
 * Renders X-axis grid lines and time tick labels with responsive support
 */

import React from 'react';
import type { TimelineViewport } from '../types';
import { dateToPosition, formatTickDate } from '../utils';

interface GridLinesProps {
  ticks: Date[];
  viewport: TimelineViewport;
  chartHeight: number;
  innerWidth: number;
  padding?: { top: number; right: number; bottom: number; left: number };
}

export const GridLines: React.FC<GridLinesProps> = ({
  ticks,
  viewport,
  chartHeight,
  innerWidth,
  padding = { top: 20, right: 20, bottom: 70, left: 180 },
}) => {
  return (
    <g>
      {ticks.map((tick, index) => {
        const x = padding.left + dateToPosition(tick, viewport, innerWidth);
        return (
          <g key={`tick-${index}`}>
            {/* Grid line */}
            <line
              x1={x}
              y1={padding.top}
              x2={x}
              y2={chartHeight - padding.bottom}
              stroke="#f3f4f6"
              strokeWidth={1}
            />
            {/* Tick label */}
            <text
              x={x}
              y={chartHeight - padding.bottom + 20}
              textAnchor="middle"
              fontSize="12"
              fill="#6b7280"
              fontFamily="system-ui, -apple-system, sans-serif"
            >
              {formatTickDate(tick)}
            </text>
          </g>
        );
      })}
    </g>
  );
};
